import visit from 'unist-util-visit';
const nonBreakingSpace = function () {
	return function transformer(tree, file) {
		visit(tree, 'text', visitor);
		function visitor(node) {
			// node.type = 'html';
			node.value = node.value
				.replace(/\s+(\?|!|:|»)/g, '\xa0$1')
				.replace(/(«)\s+/g, '$1\xa0');
		}
	};
};

export default nonBreakingSpace;
